import React from 'react';

import PropTypes from 'prop-types';
import { CSSObject } from 'styled-components';

import { Box } from '@adsk/alloy-react-box';

type ReferencePickerBlockTitleProps = {
  style?: CSSObject;
  className?: string;
  isAccordionVariant?: boolean;
  children?: React.ReactNode;
};

const ReferencePickerBlockTitle = ({
  style,
  className,
  isAccordionVariant,
  children,
}: ReferencePickerBlockTitleProps) => {
  return (
    <Box
      data-testid="reference-picker-block-title"
      className={className}
      typography="bodyMedium"
      color="charcoal900"
      backgroundColor="charcoal050"
      padding={isAccordionVariant ? '8px 16px' : '14px 16px'}
      style={style}
    >
      {children}
    </Box>
  );
};
ReferencePickerBlockTitle.propTypes = {
  /** Styles applied to the root element */
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  /** Class applied to the root element */
  className: PropTypes.string,
  /** Title content */
  children: PropTypes.node,
  /** If the block is used in the accordion variant */
  isAccordionVariant: PropTypes.bool,
};

export default ReferencePickerBlockTitle;
